import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../../components/layout";
import { Table, Card, Row, Col, Statistic } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { showLoading, hideLoading } from "../../redux/alertsSlice";

function StaffHome() {
  const [appointments, setAppointments] = useState([]);
  const [stats, setStats]               = useState([]);
  const dispatch = useDispatch();

  // Fetch both table rows and card numbers in parallel
  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(showLoading());

        const token = "Bearer " + localStorage.getItem("token");
        const [apptRes, statsRes] = await Promise.all([
          axios.get("/api/admin/get-all-appointments", { headers: { Authorization: token } }),
          axios.get("/api/admin/dashboard-stats",     { headers: { Authorization: token } }),
        ]);

        if (apptRes.data.success)  setAppointments(apptRes.data.data);
        if (statsRes.data.success)  setStats(buildStats(statsRes.data.data));
      } catch (err) {
        console.error(err);
      } finally {
        dispatch(hideLoading());
      }
    };

    fetchData();
  }, [dispatch]);

  // Convert raw numbers into objects the <Statistic> cards need
  const buildStats = (raw) => ([
    {
      title: "Total Appointments",
      value: raw.totalAppointments,
      color: "#3f8600",
      icon: <ArrowUpOutlined />,
    },
    {
      title: "Pending Approvals",
      value: raw.pendingApprovals,
      color: raw.pendingApprovals ? "#cf1322" : "#3f8600",
      icon: raw.pendingApprovals ? <ArrowUpOutlined/> : <ArrowDownOutlined/> ,
    },

 {
      title: "Approved Appointments",
      value: raw.approvedAppointments,
        color: raw.pendingApprovals ? "#cf1322" : "#3f8600",
       icon: raw.approvedApprovals ? <ArrowDownOutlined/> : <ArrowUpOutlined/>,
    },
    {
      title: "Completed Appointments",
      value: raw.completedAppointments,
      color: raw.completedAppointments ? "#3f8600" :  "#cf1322",
    icon: raw.completedAppointments ? <ArrowUpOutlined/> : <ArrowDownOutlined/>,
    },
    {
      title: "Followup Appointments",
      value: raw.followupAppointments,
      color: raw.followupAppointments ? "#3f8600" :  "#cf1322",
      icon: raw.followupAppointments ? <ArrowUpOutlined/> : <ArrowDownOutlined/>,
    },
    {
      title: "Total Doctors",
      value: raw.totalDoctors,
      color: "#3f8600",
      icon: <ArrowUpOutlined />,
    },
    {
      title: "Active Patients",
      value: raw.activePatients,
      color: "#3f8600",
      icon: <ArrowUpOutlined />,
    },
    {
      title: "New Registrations (today)",
      value: raw.newRegistrations,
      color: raw.newRegistrations ? "#3f8600" : "#cf1322",
      icon: raw.newRegistrations ? <ArrowUpOutlined/> : <ArrowDownOutlined/>,
    },
  ]);

  return (
    <Layout>
      {/* Statistic Cards */}
      <div style={{ paddingTop: 30, paddingBottom: 40 }}>
        <Row gutter={[24, 24]} justify="start">
          {stats.map((stat, idx) => (
            <Col key={idx} xs={24} sm={12} md={8} lg={6} xl={6}>
              <Card
                style={{
                  borderRadius: 16,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  transition: "all .3s ease",
                }}
                styles={{ padding: 24 }}
                hoverable
              >
                <Statistic
                  title={stat.title}
                  value={stat.value}
                  precision={0}
                  valueStyle={{ color: stat.color, fontWeight: "bold" }}
                  prefix={stat.icon}
                />
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* Appointment Table */}
      <Card title="All Appointments">
        <Table
          dataSource={appointments}
          columns={[
            {
              title: "Doctor",
              key: "doctor",
              render: (_, r) =>
                `${r.doctorInfo?.firstName || ""} ${r.doctorInfo?.lastName || ""}`,
            },
             {
              title: "Specialty",
              key: "service",
              render: (_, r) =>
                `${r.doctorInfo?.service || ""}`,
            },
            {
              title: "Patient",
              key: "patient",
              render: (_, r) => r.userInfo?.name || "N/A",
            },
            { title: "Date",    dataIndex: "date",   key: "date" },
            { title: "Status",  dataIndex: "status", key: "status" },
          ]}
          rowKey="_id"
        />
      </Card>
    </Layout>
  );
}

export default StaffHome;
